"use client";

import { useSentryErrorBoundary } from "@/lib/sentry/use-sentry-error-boundary";
import { ErrorContent } from "@/components/error-content";

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useSentryErrorBoundary(error);

  return (
    <ErrorContent
      layout="fullscreen"
      heading="This page couldn't load"
      description="Try again. If it still fails, share the Error ID shown below with support so we can find the exact failure."
      error={error}
      reset={reset}
    />
  );
}
